import * as Reflux from "reflux";
export const CustomerSearchActions = {
	onInputChange: Reflux.createAction(["onInputChange"]),
	onCustomerSelected: Reflux.createAction(["onCustomerSelected"]),
	onCardholderSelected: Reflux.createAction(["onCardholderSelected"]),
	onAddressSelected: Reflux.createAction(["onAddressSelected"]),
	onCreateCart: Reflux.createAction(["onCreateCart"]),
	onCartCreated: Reflux.createAction(["onCartCreated"]),
};
